// extracted by mini-css-extract-plugin
export default {"container":"SideMenuItem_container__0Au57","text":"SideMenuItem_text__lgU2B","icon":"SideMenuItem_icon__hGODR","externalLink":"SideMenuItem_externalLink__a001Q"};